module.exports = __webpack_public_path__ + "img/india.ddf0cb9b.png";